import React from 'react';

import './page.css';

//
import MainTitle from '../../components/page/main-title/MainTitle';
import Menu from './Menu';
import STRINGS from './../../data/language/language';
import RelatoriosClientes from './RelatoriosClientes';
import RelatoriosClientesNaoPagantes from './RelatoriosClientesNaoPagantes';
import RelatoriosAdesoes from './RelatoriosAdesoes';
import RelatoriosPlanos from './RelatoriosPlanos';
import RelatoriosGeral from './RelatoriosGeral';
import RelatoriosPagamentos from './RelatoriosPagamentos';
import ItemMenu from './ItemMenu';
import WS from '../../config/Ws';

const TYPES = {
  pagamentos: 'pagamentos',
  adesoes: 'adesoes',
  adesoes_atual: 'adesoes_atual',
  adesoes_anterior: 'adesoes_anterior',
  adesoes_boleto: 'adesoes_boleto',
  adesoes_cartao: 'adesoes_cartao',
  planos_clientes: 'planos_clientes',
  planos_mais: 'planos_mais',
  planos_data: 'planos_data',
  geral: 'geral',

  clientes_ativos: 'clientes_ativos',
  clientes_inativos: 'clientes_inativos',
  clientes_nao_pagantes: 'clientes_nao_pagantes',
  clientes_teste: 'clientes_teste',
};

class Relatorios extends React.Component{
  constructor (props){
    super(props);
    const relatorio = <RelatoriosGeral
      key={1}
      type={TYPES.geral}
      url={WS.relatorios.geral}
      title={STRINGS[window.LANGUAGE].relatorioGeral} />;

    this.state = {
      strings: STRINGS[window.LANGUAGE],
      relatorio: relatorio
    }

    this.clickHandler = this.clickHandler.bind(this);

  }

  clickHandler(dados, e) {
    e.preventDefault();
    let relatorio;

    if(dados.type){
      switch (dados.type) {
        case TYPES.clientes_ativos:
          relatorio = <RelatoriosClientes
            key={1}
            type={TYPES.clientes_ativos}
            url={WS.relatorios.clientesAtivos}
            title={this.state.strings.clientesAtivos} />
          break;
        case TYPES.clientes_inativos:
          relatorio = <RelatoriosClientes
            key={2}
            type={TYPES.clientes_inativos}
            url={WS.relatorios.clientesInativos}
            title={this.state.strings.clientesInativos} />
          break;
        case TYPES.clientes_nao_pagantes:
          relatorio = <RelatoriosClientes
            key={3}
            type={TYPES.clientes_nao_pagantes}
            url={WS.relatorios.clientesNaoPagantes}
            title={this.state.strings.clientesTestaramNaoPagaram} />
          break;
        case TYPES.clientes_teste:
          relatorio = <RelatoriosClientes
            key={4}
            type={TYPES.clientes_teste}
            url={WS.relatorios.clientesTeste}
            title={this.state.strings.clientesEmTeste} />
          break;

        case TYPES.adesoes:
          relatorio = <RelatoriosAdesoes
            key={5}
            type={TYPES.adesoes}
            url={WS.relatorios.adesoesPorData}
            title={this.state.strings.adesoes} />
          break;
        case TYPES.adesoes_atual:
          relatorio = <RelatoriosAdesoes
            key={6}
            type={TYPES.adesoes_atual}
            url={WS.relatorios.adesoesMesAtual}
            title={this.state.strings.adesoesAtual} />
          break;
        case TYPES.adesoes_anterior:
          relatorio = <RelatoriosAdesoes
            key={7}
            type={TYPES.adesoes_anterior}
            url={WS.relatorios.adesoesMesAnterior}
            title={this.state.strings.adesoesAnterior} />
          break;
        case TYPES.adesoes_boleto:
          relatorio = <RelatoriosAdesoes
            key={8}
            type={TYPES.adesoes_boleto}
            url={WS.relatorios.adesoesBoleto}
            title={this.state.strings.adesoesBoleto} />
          break;
        case TYPES.adesoes_cartao:
          relatorio = <RelatoriosAdesoes
            key={9}
            type={TYPES.adesoes_cartao}
            url={WS.relatorios.adesoesCartao}
            title={this.state.strings.adesoesCartao} />
          break;
        case TYPES.planos_clientes:
          relatorio = <RelatoriosPlanos
            key={10}
            type={TYPES.planos_clientes}
            url={WS.relatorios.clientesInativos}
            title={this.state.strings.planosClientes} />
          break;
        case TYPES.planos_mais:
          relatorio = <RelatoriosPlanos
            key={11}
            type={TYPES.planos_mais}
            url={WS.relatorios.clientesInativos}
            title={this.state.strings.planosMais} />
          break;
        case TYPES.planos_data:
          relatorio = <RelatoriosPlanos
            key={12}
            type={TYPES.planos_data}
            url={WS.relatorios.clientesInativos}
            title={this.state.strings.planosData} />
          break;
        case TYPES.pagamentos:
          relatorio = <RelatoriosPagamentos
            key={14}
            type={TYPES.pagamentos}
            url={WS.relatorios.pagamentos}
            title={this.state.strings.planosData} />
          break;
        default:
        relatorio = <RelatoriosGeral
          key={13}
          type={TYPES.geral}
          url={WS.relatorios.geral}
          title={this.state.strings.relatorioPagamentos} />
        break;
      }

      this.setState({
        relatorio
      });
    }
  }

  render() {

    const { relatorios } = this.state.strings;

    return (
      <div className="page-blocos" >
        <div className="container">
          <div className='menu-relatorios'>
            <div className='menu-relatorios__inner'>
              <div className='menu-relatorios__shadow'>
                <Menu dados={GERAL} clickHandler={this.clickHandler} />
                <Menu dados={CLIENTES} clickHandler={this.clickHandler} />
                <Menu dados={FINANCEIRO} clickHandler={this.clickHandler} />
                <Menu dados={PAGAMENTOS} clickHandler={this.clickHandler} />
                {/*<Menu dados={CAMPANHAS} />*/}
                {/*<Menu dados={PLANOS} clickHandler={this.clickHandler} />*/}
              </div>
            </div>
          </div>
          <div className="container-box container-box-relatorios">
            <div className="container-box--inner">
              <MainTitle title={relatorios}></MainTitle>
              {this.state.relatorio}
            </div>
          </div>
          <div className='clear'></div>
        </div>
      </div>
    );
  }
}

const CLIENTES =
{
  icon: 'fas fa-users',
  items: [
    { title: 'Clientes', main: true, classes: '' },
    { title: 'Ativos', classes: '', type: TYPES.clientes_ativos },
    { title: 'Inativos', classes: '', type: TYPES.clientes_inativos },
    { title: 'Em teste', classes: '', type: TYPES.clientes_teste },
    { title: 'Clientes que testaram e não pagaram', classes: '', type: TYPES.clientes_nao_pagantes }
  ]
};

const PAGAMENTOS =
{
  icon: 'fas fa-dollar-sign',
  items: [
    { title: 'Pagamentos', main: true, classes: '' },
    { title: 'Geral', classes: '', type: TYPES.pagamentos }
  ]
};

const GERAL =
{
  icon: 'fas fa-chart-line',
  items: [
    { title: 'Relatórios', main: true, classes: '' },
    { title: 'Geral', classes: '', type: TYPES.geral }
  ]
};

const PLANOS =
{
  icon: 'fas fa-tasks',
  items: [
    { title: 'Planos', main: true, classes: '' },
    { title: 'Clientes por plano', classes: '', type: TYPES.planos_clientes },
    //{ title: 'Com mais clientes', classes: '', type: TYPES.planos_mais },
    //{ title: 'Filtrar por masculino', classes: '' },
    //{ title: 'Filtrar por feminino', classes: '' },
    { title: 'Clientes por data', classes: '', type: TYPES.planos_data }
  ]
};

const CAMPANHAS =
{
  icon: 'fas fa-newspaper',
  items: [
    { title: 'Campanhas', main: true, classes: '' },
    { title: 'Clientes por campanha', classes: '' },
    { title: 'Mais clientes', classes: '' },
    { title: 'Menos clientes', classes: '' }
  ]
};

const FINANCEIRO =
{
  icon: 'fas fa-money-bill',
  items: [
    { title: 'Adesões', main: true, classes: '' },
    { title: 'Filtrar por data', classes: '', type: TYPES.adesoes },
    { title: 'Mês atual', classes: '', type: TYPES.adesoes_atual },
    { title: 'Mês anterior', classes: '', type: TYPES.adesoes_anterior},
    { title: 'Compras no boleto', classes: '', type: TYPES.adesoes_boleto },
    { title: 'Compras no cartão', classes: '', type: TYPES.adesoes_cartao },
  ]
};

export default Relatorios;



// WEBPACK FOOTER //
// ./src/classes/relatorios/Relatorios.js